(function () {

  function fixCartNavidium() {

    // Restore Empire top checkout button
    document.querySelectorAll('.cart-title-button').forEach(function (button) {
      button.classList.remove('rale-checkout--invisible');
      button.style.display = '';
    });


    // Remove Navidium from top cart checkout area only
    document.querySelectorAll('.cart-title-right .nvd-mini').forEach(function (widget) {
      widget.remove();
    });

  }


  function removeAtcNavidium() {

    // Remove Navidium mounts from the add-to-cart popup
    document.querySelectorAll(
      '.atc-banner__form .nvd-mini, .atc-banner--cart .nvd-mini'
    ).forEach(function (widget) {
      widget.remove();
    });

  }


  function runFixes() {
    fixCartNavidium();
    removeAtcNavidium();
  }


  window.addEventListener('load', function () {
    setTimeout(runFixes, 500);
    setTimeout(runFixes, 1500);
    setTimeout(runFixes, 3000);
  });


  document.addEventListener('nvd_cart_changed', function () {
    setTimeout(runFixes, 500);
    setTimeout(runFixes, 1500);
  });


  const observer = new MutationObserver(function () {
    removeAtcNavidium();
  });


  window.addEventListener('load', function () {

    const atcArea = document.querySelector('.atc-banner');

    if (atcArea) {
      observer.observe(atcArea, {
        childList: true,
        subtree: true
      });
    }

  });


})();
